"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');

var _upgrade = require('shared/enum/upgrade');


var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);

var _freeCapAnalytics = require('web/services/freeCapAnalytics');
var _types = require('./types');










const activeSubscriptionSteps = [_types.UpgradeStep.PREVIEW, _types.UpgradeStep.SUMMARY, _types.UpgradeStep.BILLING] 
const noSubscriptionSteps = [_types.UpgradeStep.PREVIEW, _types.UpgradeStep.SUMMARY] 

 const useCombinedCheckoutFlow = ({
  hasReceipt,
  onCheckout,
  teamUnits,
  smsUnits,
  isSmsSelected,
  analyticsContext,
}) => {
  const availableSteps = hasReceipt
    ? activeSubscriptionSteps
    : noSubscriptionSteps

  const [currentStep, setCurrentStep] = _react.useState(availableSteps[0])
  const [isLoadingCheckout, setIsLoadingCheckout] = _react.useState.call(void 0, false)

  _react.useEffect.call(void 0, 
    () => {
      _amplitude2.default.logEvent(`TEAM_COMMUNICATION_UPGRADE_${currentStep.toUpperCase()}`)
    },
    [currentStep],
  )

  _react.useEffect.call(void 0, 
    () => {
      _freeCapAnalytics.trackTeamCommunicationUpgradeStep.call(void 0, analyticsContext, currentStep, {
        has_subscription: hasReceipt,
        checkout_units: teamUnits,
        includes_sms: isSmsSelected,
      })
    },
    [analyticsContext, currentStep, hasReceipt, isSmsSelected, teamUnits],
  )

  const onPrev = _react.useCallback.call(void 0, 
    () => {
      const currentStepIdx = availableSteps.findIndex(x => x === currentStep)
      setCurrentStep(availableSteps[currentStepIdx - 1] || availableSteps[0])
    },
    [availableSteps, currentStep],
  )

  const onNext = _react.useCallback.call(void 0, 
    async () => {
      if (currentStep === availableSteps[0]) {
        return setCurrentStep(availableSteps[1])
      }
      if (currentStep === availableSteps[1] && availableSteps[2]) {
        return setCurrentStep(availableSteps[2])
      }
      if (!teamUnits) return

      const items = [{ Type: _upgrade.SubscriptionItemType.TEAM, Units: teamUnits }]
      if (isSmsSelected && smsUnits) {
        items.push({ Type: _upgrade.SubscriptionItemType.SMS, Units: smsUnits })
      }

      setIsLoadingCheckout(true)
      await onCheckout(items, { action: _upgrade.CheckoutActionType.UPGRADE })
      setIsLoadingCheckout(false)
    },
    [availableSteps, currentStep, isSmsSelected, onCheckout, smsUnits, teamUnits],
  )

  return {
    onPrev,
    onNext,
    currentStep,
    isLoadingCheckout,
  }
}; exports.useCombinedCheckoutFlow = useCombinedCheckoutFlow
